import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AdddenominationComponent } from '../adddenomination/adddenomination.component';

@Component({
  selector: 'app-addcurrency',
  templateUrl: './addcurrency.component.html',
  styleUrls: ['./addcurrency.component.css']
})
export class AddcurrencyComponent implements OnInit{

  //terms Values
  isaddterms:boolean=false;
  iseditterms:boolean=false;
  isdeleteterms:boolean=false;
  isviewterms:boolean=false;
  
  //Save Validation
  submitted:boolean;
  successfully:boolean;
  saveloading:boolean;

  currencydenominationColl:any=[];
  //Edit Get Values
  currencyColl:any=[];
  currencyid:number=0
  
  
  txtdenomination:number=0
  
  currencyform=new FormGroup({     
    currencyid:new FormControl(null),     
    currencyname:new FormControl('',Validators.required), 
    currencydigits:new FormControl(null), 
    inactive:new FormControl(false),     
  });
  
  isloading:boolean=false;
  isprivilage:boolean=false;  
  showProgress:boolean=false;
  formname:String="Currency";
  confirmationDialogService: any;

  @Input() currencyname: any = '';
  @Output() emitData = new EventEmitter();
  
  constructor(private appService: DhukanDataService,private route: ActivatedRoute, private productFindService: NgbModal,private activeModal: NgbActiveModal, 
     public router: Router,private toastr: ToastrService,private loginService:LoginDataService) { 
       this.route.queryParams.subscribe(params => {
        if(params.id!==undefined){
          this.currencyid = params.id
        }  
       });
       this.fnServiceChanges();
  }
  
  fnServiceChanges() {
    this.loginService.serviceloginChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
      if (this.loginService.fnCheckUser()) {

        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnCompanyFaildRedirect();
      }         
      }
      else {
        this.fnUserFailedForm();
      }
    });
  }

  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
      if (this.loginService.fnCheckUser()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnGetUserRoleList();
      }
    }
    else {
      this.loginService.fnCompanyFaildRedirect();
    }         
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {
    try {
      this.isaddterms = true;
      this.currencyform.reset();
      this.fnInitializeCurrencyFormGroup();

      if (this.currencyid > 0) {
        this.fngetCurrency();
      }
    
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  
  
  
  fnCheckUserPririvilage(){
    var _check:boolean=false;
    if (this.currencyid>0){
      _check= this.loginService.fnCheckUserRoleAction(this.formname,'ALTER')
    }else{
      _check= this.loginService.fnCheckUserRoleAction(this.formname,'CREATE')
    }
  
    return _check;
  }
  
  fnUserFailedForm(){
    this.isprivilage=true;
  }
  
  
  fnInitializeCurrencyFormGroup(){
     this.currencyform.setValue({
      currencyid:0, 
      currencyname:'',  
      currencydigits:null,  
      inactive:false,      
     })
  }
  
  
  
  
  //Get 
  fngetCurrency() {        
       var data = {
         'currencyid':this.currencyid,    
         'companyid': this.loginService.fnGetCompanyId(),        
       }
       this.appService.getCurrency(data)
       .subscribe(
         (res)=>{                  
           var result=res.json().result;
       //console.log(result)
           this.currencyColl=result[0];
           var editdata =this.currencyColl[0];
           this.fnEditterms(editdata);

           this.currencydenominationColl=result[1];
       },
       (err)=>{          
         this.toastr.error('Error', err);
       })
  }
  
  
    
 
  
  //Save Btn Click
  fnSaveBtnClick(){
     try{
       if(this.saveloading){
         return
       }
       this.submitted=true;
       this.successfully=false;
       //Validate
       if(this.currencyform.valid){
           //Check
           this.saveloading=true
           var data = {
                 'currencyid': this.currencyid,                   
                 'currencyname':this.currencyform.get('currencyname').value,  
                 'currencydigits':this.currencyform.get('currencydigits').value,
                 'companyid': this.loginService.fnGetCompanyId(),  
                 'inactive':this.currencyform.get('inactive').value,            
                 'createdby': this.loginService.fnGetModUserId(),    
                 'modifiedby':this.loginService.fnGetModUserId(), 
                 'currencydenominationColl':this.currencydenominationColl
           }
           this.appService.fnCheckCurrency(data).subscribe(
             (res)=>{
                 var _checkresult=res.json().result[0].checkfield;
               
                 if(_checkresult==="done"){
                       if (this.currencyform.get('currencyid').value>0){
                         //Update Department
                         this.fnSetCurrency(data);
                       }
                       else{
                         //Insert Department
                         this.fnInsertCurrency(data);
                       }
                 }
                 else{        
                       if(_checkresult==="name"){
                        this.saveloading=false

                         this.currencyform.controls['currencyname'].setErrors({'notfound': true});
                       }
                 }
           },
           (err)=>{
            this.saveloading=false

               this.toastr.error('Error', err);           
           });
        }
     }catch(ex){
      this.saveloading=false

       this.fnShowErrorMsg(ex);
     }
  }
  
  //Insert
  fnInsertCurrency(data){    
   
     this.appService.fnInsertCurrency(data).subscribe(
       (res)=>{
        this.saveloading=false

       if(res.json().status===200){
         this.toastr.success('', "The new Currency has been added successfully.Insert Successfully");
  
         this.fnInsertActivityLog('INSERT',0,data.currencyid);
  
         this.emitData.emit(this.currencyid);
          this.activeModal.close(true);
       }},
       (err)=>{
        this.saveloading=false

         this.toastr.error('Error', err);
       });
  
  }
  
  //Set
  fnSetCurrency(data){    
  
  this.appService.fnSetCurrency(data).subscribe(
   (res)=>{
    this.saveloading=false

   if(res.json().status===200){
       this.toastr.success('', "The Currency has been updated successfully.");
  
       this.fnInsertActivityLog('EDIT',this.currencyid,data.currencyname);
  
       this.emitData.emit(this.currencyid);
       this.activeModal.close(true); 
   }},
   (err)=>{
    this.saveloading=false

     this.toastr.error('Error', err);
   });
  
  }
  fnAddDenomination() {

    const modalRef = this.productFindService.open(AdddenominationComponent, { size: <any>'m' });

    modalRef.componentInstance.denominationColl= this.currencydenominationColl
   

    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {
      //console.log(receivedEntry)
      this.currencydenominationColl.push(receivedEntry);
    
      
    });
    
  }
  fnEditDenominationDetails(index) {


    const modalRef = this.productFindService.open(AdddenominationComponent, { size: <any>'l' });

    var data = this.currencydenominationColl[index];
    
    //console.log(data)

    modalRef.componentInstance.denominationid = data.denominationid;

    modalRef.componentInstance.denomination = data.denomination;
    modalRef.componentInstance.currencydenominationColl = this.currencydenominationColl;

    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {


      this.currencydenominationColl[index].denominationid = receivedEntry.denominationid;
     
      this.currencydenominationColl[index].denomination = receivedEntry.denomination;

    });

  }

  fnDeleteDenominationConfirm(index) {
    try {
      this.confirmationDialogService.confirm('Confirm..', 'Do you  want to delete details?')
        .then((confirmed) => {
          if (confirmed) {
            this.currencydenominationColl.splice(index, 1)
          }
        }
        );
      //.catch(() => );
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }



  fnDeleteLeavepolicyDetails(index) {



  }


  //Close
  public decline() {
    this.activeModal.close(false);
  }







  private fnEditterms(deptBO){
  
   this.currencyform.setValue({
    currencyid:deptBO.currencyid,      
    currencyname:deptBO.currencyname,
    currencydigits:deptBO.currencydigits,
    inactive:deptBO.inactive,   
   });
  
  
  this.isaddterms=false;
  this.iseditterms=true;
  this.isdeleteterms=false;
  this.isviewterms=false;
  }
  
  
  fnInsertActivityLog(action,refno,desc){
    try{
      var data={
        logtype:action,
        logat:this.formname,
        refnum:refno,
        logdescr:desc,
        logby:this.loginService.fnGetModUserId(),
        'companyid': this.loginService.fnGetCompanyId(),
      }
    
  
      this.appService.fnInsertActivity(data).subscribe(
        (res)=>{
        },
        (err)=>{
       
        });
  
    }catch{
  
    }
  }
  
  
  
  private fnShowProgress(){
    this.showProgress=true;
  }
  private fnHideProgress(){
    this.showProgress=false;
  }
  
  private  fnShowErrorMsg(ex){
  this.toastr.warning('Internal Error', ex);       
  }
  
  
  
  
  
  }
  